import { render, staticRenderFns } from "./CoLearnApprovalNotification.vue?vue&type=template&id=352a3912&scoped=true&"
import script from "./CoLearnApprovalNotification.vue?vue&type=script&lang=js&"
export * from "./CoLearnApprovalNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a3912",
  null
  
)

export default component.exports